import * as React from 'react'

interface SegmentedControlProps {
  activeTab: string,
  size: string,
  buttons: {
    activeIconSrc?: string,
    disabled?: boolean,
    inactiveIconSrc?: string,
    labelIcon?: JSX.Element,
    label: string,
    onClick: (e: React.SyntheticEvent) => void
  }[],
  label?: string;
  labelAdjacentElement?: JSX.Element,
  variant?: 'bordered' | 'borderless'
}

export const SegmentedControl = ({ activeTab, size, buttons, label, labelAdjacentElement, variant, }: SegmentedControlProps) => {
  const labelElement = label && <legend className={`segmented-control-legend ${size}`}>{label}</legend>
  const labelWrapper = labelAdjacentElement ? <div className="label-wrapper">{labelElement}{labelAdjacentElement}</div> : labelElement

  return(
    <fieldset className="segmented-control-wrapper">
      {labelWrapper}
      {/* toggle buttons with aria-pressed, deliberately not a radiogroup */}
      <div className={variant === 'borderless' ? 'segmented-control-container borderless' : 'segmented-control-container'}>
        {buttons.map((button, i) => {
          const { activeIconSrc, disabled, inactiveIconSrc, label, onClick, labelIcon, } = button
          let style = size
          if(i === 0) {
            style += ' left'
          } else if(i === buttons.length - 1) {
            style += ' right'
          }
          if(disabled) {
            style += ' disabled'
          }
          return (
            <button aria-pressed={label === activeTab} className={`interactive-wrapper segmented-control-button focus-on-light ${style} ${label === activeTab ? 'active' : ''}`} disabled={disabled} key={`${label}-${i}`} onClick={onClick} type="button" value={label}>
              {activeIconSrc && inactiveIconSrc && <img alt="" className="active-or-inactive-icon" src={label === activeTab ? activeIconSrc : inactiveIconSrc} />}
              {labelIcon}
              <span>{label}</span>
            </button>
          )
        })}
      </div>
    </fieldset>
  )
}

export default SegmentedControl
